import React, { useState } from 'react';
import { Button, Container, Form, Header, Icon, Message, Segment } from 'semantic-ui-react';
import { useNavigate } from 'react-router-dom';
import { login } from '../api/UserApi';
import { setAccessToken } from '../common/Configuration';

const LoginFormPage = () => {
  const navigate = useNavigate();
  const [loginId, setLoginId] = useState('');
  const [loginPw, setLoginPw] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async () => {
    if (!loginId || !loginPw) return;
    setLoading(true);
    setError('');
    try {
      const result = await login(loginId, loginPw);
      if (result && result.errorCode === 0) {
        // TODO: 토큰 저장 및 관리자 메인 페이지로 이동
        // result.response에 UserAccessTokenDto가 들어있음
       
        setAccessToken(result.response?.accessToken || '', result.response?.refreshToken || '');
        navigate('/main/dashboard');
        
      } else {
        setError('로그인에 실패했습니다.');
      }
    } catch (e) {
      setError('로그인 중 오류가 발생했습니다.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container text style={{ height: '100vh', display: 'flex', alignItems: 'center' }}>
      <Segment raised style={{ width: '100%' }}>
        <Header as="h2" textAlign="center">
          관리자 로그인
        </Header>
        <Form onSubmit={handleSubmit}>
          <Form.Input
            label="아이디"
            placeholder="관리자 아이디를 입력하세요"
            value={loginId}
            onChange={(_, data) => setLoginId(data.value)}
          />
          <Form.Input
            label="비밀번호"
            type="password"
            placeholder="비밀번호를 입력하세요"
            value={loginPw}
            onChange={(_, data) => setLoginPw(data.value)}
          />
          {error && (
            <Message negative>
              <Message.Header>로그인 실패</Message.Header>
              <p>{error}</p>
            </Message>
          )}
          <Button
            primary
            fluid
            size="large"
            loading={loading}
            disabled={!loginId || !loginPw || loading}
          >
            <Icon name="sign in" />
            로그인
          </Button>
        </Form>
        <Button basic fluid style={{ marginTop: 12 }} onClick={() => navigate('/login')}>
          뒤로가기
        </Button>
      </Segment>
    </Container>
  );
};

export default LoginFormPage;
